import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';

const LocationListSidebar = ({ images, onLocationClick, selectedImage, getMarkerColor }) => {
  const theme = useTheme();
  
  // Filter images with valid location data
  const locationsWithData = images.filter(img => 
    img.location && (img.location.lat !== 0 || img.location.lng !== 0)
  );
  
  return (
    <Box sx={{ overflow: 'auto', maxHeight: 'calc(100% - 56px)' }}>
      {locationsWithData.length > 0 ? (
        <Box component="ul" sx={{ p: 0, m: 0, listStyle: 'none' }}>
          {locationsWithData.map((img, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                p: 2,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                '&:last-child': { borderBottom: 'none' },
                cursor: 'pointer',
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) },
                bgcolor: selectedImage === img ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                transition: 'background-color 0.2s ease'
              }}
              onClick={() => onLocationClick(img)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box 
                  sx={{ 
                    width: 12, 
                    height: 12, 
                    borderRadius: '50%', 
                    bgcolor: getMarkerColor(img.type), 
                    mr: 1 
                  }} 
                />
                <Typography variant="subtitle2" noWrap>
                  {img.type || 'Inspection Photo'}
                </Typography>
              </Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Lat: {img.location.lat.toFixed(6)}
              </Typography>
              <Typography variant="caption" color="text.secondary" display="block">
                Lng: {img.location.lng.toFixed(6)}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            No location data available
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LocationListSidebar;
